<div class="afrobot-wrapper">
  <!-- Fenêtre du chatbot -->
  <div class="afrobot-chat" *ngIf="isOpen">
    <div class="chat-header">
      <span class="afrobot-name">
        <span class="bot-emoji">
          🌍
          <div class="online-status"></div>
        </span>
        <strong>AfroBot (Beta)</strong>
      </span>
      <div class="header-actions">
        <button class="clear-chat-btn" (click)="clearChat()" title="Nouvelle conversation">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
          </svg>
        </button>
        <button class="close-btn" (click)="toggleChat()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="chat-body">
      <!-- Indicateur de questions restantes pour les invités -->
      <div class="questions-counter" *ngIf="!isLoggedIn && remainingGuest > 0">
        <div class="counter-badge">
          {{ remainingGuest }}
          question{{ remainingGuest !== 1 ? 's' : '' }}
          gratuite{{ remainingGuest !== 1 ? 's' : '' }}
          restante{{ remainingGuest !== 1 ? 's' : '' }}
        </div>
      </div>

      <!-- Compteur pour les utilisateurs connectés -->
      <div class="questions-counter" *ngIf="isLoggedIn && remainingLogged > 0">
        <div class="counter-badge logged-user">
          {{ remainingLogged }}
          question{{ remainingLogged !== 1 ? 's' : '' }}
          gratuite{{ remainingLogged !== 1 ? 's' : '' }}
          restante{{ remainingLogged !== 1 ? 's' : '' }}
        </div>
      </div>

      <div *ngFor="let msg of messages; trackBy: trackByMessageId">

        <!-- Message utilisateur avec actions inline -->
        <ng-container *ngIf="msg.from === 'user'">
          <!-- Mode normal -->
          <div class="message-row user-row" *ngIf="editingMessageId !== msg.id">
            <!-- Actions à gauche (visibles au survol) -->
            <div class="quick-actions left-actions" 
                 *ngIf="isLastUserMessage(msg.id!) && !isLoading">
              <button class="quick-btn edit-btn" 
                      (click)="startEditMessage(msg.id!)" 
                      [disabled]="!canAskQuestion()"
                      title="Modifier">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
              </button>
              <button class="quick-btn retry-btn" 
                      (click)="retryMessage(msg.id!)" 
                      [disabled]="!canAskQuestion()"
                      title="Relancer">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="23 4 23 10 17 10"/>
                  <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                </svg>
              </button>
            </div>

            <!-- Message utilisateur -->
            <div class="user-message">
              {{ msg.text }}
              <span class="edit-badge" *ngIf="msg.edited">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                </svg>
              </span>
            </div>
          </div>

          <!-- Mode édition inline -->
          <div class="edit-mode" *ngIf="editingMessageId === msg.id">
            <div class="edit-wrapper">
              <textarea 
                #editTextarea 
                class="edit-input" 
                [(ngModel)]="editingText"
                (keydown)="onEditKeyDown($event)"
                (input)="autoResizeTextarea($event.target)"
                placeholder="Modifiez votre question..."
                rows="1">
              </textarea>
              <div class="edit-buttons">
                <button class="mini-btn cancel-btn" (click)="cancelEdit()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
                <button class="mini-btn save-btn" 
                        (click)="saveEdit()" 
                        [disabled]="!editingText.trim()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Message bot avec feedback -->
        <ng-container *ngIf="msg.from === 'bot' && msg.text && msg.text.trim() !== ''">
          <div class="message-row bot-row">
            <!-- Message bot -->
            <div class="bot-message">
              <markdown [data]="msg.text" linkTarget="_blank"></markdown>
              
              <!-- Feedback inline modernisé -->
              <div class="feedback-actions" *ngIf="msg.id !== 'welcome-message'">
                <button class="feedback-btn like-btn" 
                        [class.active]="msg.feedback === 'like'"
                        (click)="giveFeedback(msg.id!, 'like')"
                        title="Réponse utile">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" [attr.fill]="msg.feedback === 'like' ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
                  </svg>
                  <span class="feedback-label">Utile</span>
                </button>
                <button class="feedback-btn dislike-btn" 
                        [class.active]="msg.feedback === 'dislike'"
                        (click)="giveFeedback(msg.id!, 'dislike')"
                        title="Réponse peu utile">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" [attr.fill]="msg.feedback === 'dislike' ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"/>
                  </svg>
                  <span class="feedback-label">Pas utile</span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Animation de frappe -->
        <ng-container *ngIf="msg.from === 'typing'">
          <div class="message-row bot-row">
            <div class="typing-indicator">
              <div class="typing-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Prompt de connexion -->
        <ng-container *ngIf="msg.from === 'login-prompt'">
          <div class="login-prompt-container">
            <div class="login-prompt">
              <div class="login-prompt-content">
                <div class="login-prompt-icon">🔐</div>

                <!-- Invité -->
                <div *ngIf="!isLoggedIn">
                  <div class="login-prompt-title">Oups ! Questions gratuites épuisées</div>
                  <div class="login-prompt-text">
                    Tu sembles vraiment passionné par la tech africaine ! 🚀
                    <br><br>
                    Pour continuer notre conversation et accéder à toutes mes connaissances,
                    connecte-toi ou crée ton compte AfroTech Hub.
                  </div>
                  <div class="login-prompt-actions">
                    <button class="login-btn primary" (click)="navigateToLogin()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                        <polyline points="10 17 15 12 10 7"/>
                        <line x1="15" y1="12" x2="3" y2="12"/>
                      </svg>
                      Se connecter
                    </button>
                    <button class="login-btn secondary" (click)="navigateToSignup()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                        <circle cx="8.5" cy="7" r="4"/>
                        <line x1="20" y1="8" x2="20" y2="14"/>
                        <line x1="23" y1="11" x2="17" y2="11"/>
                      </svg>
                      Créer un compte
                    </button>
                  </div>
                  <div class="login-prompt-benefits">
                    <div class="benefit">📚 Accès à toutes les ressources</div>
                    <div class="benefit">💾 Historique des conversations</div>
                  </div>
                </div>

                <!-- Connecté -->
                <div *ngIf="isLoggedIn">
                  <div class="login-prompt-title">Nombre de questions gratuites atteint</div>
                  <div class="login-prompt-text">
                    Tu as utilisé toutes tes <strong>{{ maxQuestionsLogged }}</strong> questions gratuites.
                    <br><br>
                    Pour continuer avec AfroBot et bénéficier d'un service premium personnalisé,
                    contacte notre équipe.
                  </div>
                  <div class="login-prompt-actions">
                    <button class="login-btn primary" (click)="navigateToContact()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                      </svg>
                      Nous contacter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div #chatEnd></div>
    </div>

    <form class="chat-input" (ngSubmit)="sendMessageN8n()" [class.disabled]="isInputDisabled">
      <input #messageInput 
             type="text" 
             [(ngModel)]="userMessage" 
             name="message" 
             [placeholder]="inputPlaceholder"
             (keydown)="onKeyDown($event)" 
             [disabled]="isInputDisabled" 
             required />
      <button type="submit" class="send-button" [disabled]="!userMessage.trim() || isInputDisabled">
        <svg *ngIf="!isLoading && canAskQuestion()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
        <svg *ngIf="isLoading" class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="2" x2="12" y2="6"/>
          <line x1="12" y1="18" x2="12" y2="22"/>
          <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/>
          <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/>
          <line x1="2" y1="12" x2="6" y2="12"/>
          <line x1="18" y1="12" x2="22" y2="12"/>
          <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/>
          <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/>
        </svg>
        <svg *ngIf="!canAskQuestion() && !isLoading" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      </button>
    </form>
  </div>

  <!-- Bouton flottant -->
  <button class="afrobot-floating-button" (click)="toggleChat()" *ngIf="!isOpen">
    <span class="floating-emoji">🌍</span>
    <div class="notification-badge" *ngIf="hasUnreadMessages">1</div>
  </button>
</div>